// weddingEvents.js

const weddingEvents = {
  id: 9,
  title: "Wedding Events",
  questions: [
    {
      question: "Do you organize destination weddings?",
      answer:
        "Yes, we specialize in destination weddings across India and international locations.",
    },
    {
      question: "Can you manage complete wedding planning?",
      answer:
        "Yes, we handle decor, venue, hospitality, logistics, entertainment, and guest management.",
    },
    {
      question: "Do you provide vendor coordination?",
      answer:
        "Yes, we coordinate photographers, caterers, decorators, and entertainment vendors.",
    },
  ],
};

export default weddingEvents;